import React from "react";
import * as FileSaver from "file-saver";
import XLSX from "sheetjs-style";
import Button from "@mui/material/Button";
import VerticalAlignTopIcon from "@mui/icons-material/VerticalAlignTop";
import FileDownloadIcon from '@mui/icons-material/FileDownload';

// Function to format the date from yyyy-mm-dd to dd-mm-yyyy
function formatDate(date) {
  const [year, month, day] = date.split('-'); // Split the date string into year, month, and day
  return `${day}-${month}-${year}`; // Return in dd-mm-yyyy format
}

const ExportDayWise = ({ excelData, fileName, title }) => {
  const fileType =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset-UTF-8";
  const fileExtension = ".xlsx";

  const exportTOExcel = async () => {
    const transformedData = transformData(excelData);
    const ws = XLSX.utils.json_to_sheet(transformedData);

    // Apply column widths and styles (if required)
    const wscols = [{ wch: 20 }, { wch: 30 }, { wch: 10 }, ...Array(excelData.dates.length).fill({ wch: 15 })];
    ws["!cols"] = wscols;

    // Create workbook and export
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, fileName + fileExtension);
  };

  const transformData = (data) => {
    const { userGroups, dates } = data;

    // Flatten userGroups and reports
    const transformed = [];
    userGroups.forEach((group) => {
      group.reports.forEach((report) => {
        const row = { "Group Name": group.groupName, "Report Name": report.name };

        // Add views corresponding to each date
        dates.forEach((date, index) => {
          const formattedDate = formatDate(date); // Format the date here
          row[formattedDate] = report.views[index] || 0; // Use 0 if no view count exists
        });

        transformed.push(row);
      });
    });

    return transformed;
  };

  return (
    <div>
      <Button
        style={{
          backgroundColor: "#a70e13",
          fontSize: "14px",
          color: "#ffffff",
          padding: "10px",
          borderRadius: "6px",
        }}
        onClick={exportTOExcel}
        className="export-button"
      >
        <FileDownloadIcon className="export-icon" />
        {title}
      </Button>
    </div>
  );
};

export default ExportDayWise;
